// типы верификации документов после подписания
export enum ModesDocumentVerificationAfterSigning {
  resigning = "document-verification-signature-stage-first",
  standart_signing = "document-verification-signature",
}
